/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_2_DescInputs */

const en_mk_cli_2_desc = /** @type {(inputs: Mk_Cli_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep init prepares instructions and checks for supported agents, following your project rules.`)
};

const id_mk_cli_2_desc = /** @type {(inputs: Mk_Cli_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep init menyiapkan petunjuk kerja dan pemeriksaan untuk agent yang didukung, mengikuti aturan proyekmu.`)
};

/**
* | output |
* | --- |
* | "bystep init prepares instructions and checks for supported agents, following your project rules." |
*
* @param {Mk_Cli_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_2_desc = /** @type {((inputs?: Mk_Cli_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_2_desc(inputs)
	return en_mk_cli_2_desc(inputs)
});